
import Vue from 'vue'
import { PaymentDto } from '@ViewModels/PaymentDto'
import * as Api from '@/api/StorePaymentApi'
import { Alert, Currency } from '@/components'
import { SaveButton } from '@/components/buttons'
import { Textbox, Emailbox } from '@/components/formGroups'

export default Vue.extend({
   name: 'SuccessSection',
   props: {
      paymentId: { type: String, required: true },
      data: { required: true, type: Object as () => PaymentDto },
      displayData: { required: true, type: Object },
   },
   data() {
      return {
         emailAddress: '',
         submitted: false,
         processing: false,
         success: false,
      }
   },
   computed: {
      validationMessages(): string[] {
         const messages: string[] = []
         if (this.emailAddress.length === 0) {
            messages.push('Email Address is required')
         } else if (
            this.emailAddress.length < 5 ||
            !this.emailAddress.includes('@') ||
            !this.emailAddress.includes('.')
         ) {
            messages.push('Email Address is not valid')
         }
         return messages
      },
      isValid(): boolean {
         return this.validationMessages.length === 0
      },
      allowSubmission(): boolean {
         return !this.submitted || this.isValid
      },
      showValidationError(): boolean {
         return !this.isValid && this.submitted
      },
   },
   methods: {
      async emailReceipt() {
         this.submitted = true
         if (this.isValid) {
            try {
               this.processing = true
               const result = await Api.emailReceipt(
                  this.paymentId,
                  this.emailAddress,
                  this.data.CardNumber,
                  this.data.NameOnCard
               )
               this.processing = false
               this.success = true
            } catch (err) {
               this.processing = false
            }
         }
      },
   },
   components: {
      Alert,
      Textbox,
      SaveButton,
      Currency,
      Emailbox,
   },
})
